import moment from "moment";
import { isDateClosedOutForRoom } from "../../modules/isDateClosedOutForRoom";
import { formatCurrency } from "../../../../../utils/formatCurrency";

export const RackRateManagement = (props) => {
  const {
    dateColumns,
    currentMonth,
    selectedYear,
    rentPerDayByDate,
    handleCellClick,
    roomId,
    closeout,
    rentperday,
  } = props;
  return (
    <tr>
      <td className="sticky-column">
        <strong>Rack Rate</strong>
      </td>
      {dateColumns.map((date) => {
        const day = moment(date, "DD MMM").date();
        const dateKey = moment(
          `${day}-${currentMonth.month() + 1}-${selectedYear}`,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");
        const rentForDate = rentPerDayByDate[roomId][dateKey] || rentperday;
        return (
          <td
            key={`${roomId}-${date}-rent`}
            className="availability-cell"
            onClick={() => handleCellClick(roomId, dateKey)}
            style={{
              cursor: "pointer",
              backgroundColor: isDateClosedOutForRoom(roomId, dateKey, closeout)
                ? "#f4e736"
                : "transparent",
            }}
          >
            <div>{rentForDate ? formatCurrency(rentForDate) : "N/A"}</div>
          </td>
        );
      })}
    </tr>
  );
};
